import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const removeBomDefaultPartInputSchema = z.object({
    bomId: requiredUuidString('BOM is required.', 'Invalid BOM selection.'),
    partId: requiredUuidString('Part is required.', 'Invalid part selection.'),
});
//# sourceMappingURL=remove-default-part-input.js.map